var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6562 7.14887L11.8375 9.60887L12.6818 13.2714C12.7265 13.4628 12.7138 13.6632 12.6452 13.8475C12.5766 14.0317 12.4552 14.1917 12.2962 14.3073C12.1372 14.423 11.9477 14.4892 11.7512 14.4977C11.5548 14.5062 11.3602 14.4566 11.1918 14.3551L7.99747 12.4176L4.80996 14.3551C4.64157 14.4566 4.447 14.5062 4.25057 14.4977C4.05415 14.4892 3.86459 14.423 3.70559 14.3073C3.54659 14.1917 3.42521 14.0317 3.35662 13.8475C3.28803 13.6632 3.27528 13.4628 3.31996 13.2714L4.16309 9.61262L1.34372 7.14887C1.1946 7.02026 1.08677 6.85048 1.03375 6.66084C0.980734 6.47119 0.98489 6.27011 1.0457 6.08281C1.10651 5.89552 1.22126 5.73034 1.37556 5.608C1.52987 5.48567 1.71686 5.41161 1.91309 5.39512L5.62934 5.07324L7.07997 1.61324C7.15572 1.43169 7.2835 1.27661 7.44721 1.16753C7.61092 1.05845 7.80324 1.00024 7.99997 1.00024C8.19669 1.00024 8.38901 1.05845 8.55272 1.16753C8.71643 1.27661 8.84421 1.43169 8.91997 1.61324L10.375 5.07324L14.09 5.39512C14.2862 5.41161 14.4732 5.48567 14.6275 5.608C14.7818 5.73034 14.8966 5.89552 14.9574 6.08281C15.0182 6.27011 15.0223 6.47119 14.9693 6.66084C14.9163 6.85048 14.8085 7.02026 14.6593 7.14887H14.6562Z",
    fill: "#0802B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.2cdbb4a719c957585809ab99ca2345b5.svg";
export { ForwardRef as ReactComponent };